export default "__VITE_ASSET__B07B4VPj__"